(function () {
  var root = document.documentElement;
  var modalSelectors = ['#shopify-pc__banner', '#shopify-pc__prefs__dialog'];

  function isVisible(element) {
    if (!element || element.hidden) return false;

    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      element.getClientRects().length > 0;
  }

  function syncCookieModal() {
    var activeDialog = null;

    modalSelectors.some(function (selector) {
      var dialog = document.querySelector(selector);
      if (isVisible(dialog)) {
        activeDialog = dialog;
        return true;
      }
      return false;
    });

    root.classList.toggle('shopify-cookie-modal-open', Boolean(activeDialog));

    if (activeDialog) {
      activeDialog.setAttribute('aria-modal', 'true');
    }
  }

  var observer = new MutationObserver(syncCookieModal);

  function initialise() {
    syncCookieModal();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('[id^="shopify-pc__banner__btn"], #shopify-pc__prefs__dialog button')) {
        window.requestAnimationFrame(syncCookieModal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
